export class CustomerAppointment {
     customerId?: number;
     age?: number;
     sex?: number;
     pelephone?: string;
     imagePath?: string;
     comments?: string;
     fl?: string;
     isVip?: boolean;
     isBirthDay?: boolean;
     isDebt?: boolean;
     isHaveCancelAppointments?: boolean; // availability of cancelling meetings
     cCount?: number;  // amount of cancelled meetings
     birthDay?: number | string;
     birthMonth?: number | string;
     collectDebt?: number;
}

export class CustomerAppointmentLazy {
     page: number;
     size: number;
     sortField: string;
     sortOrder: number;
}

export class CustomerAppointmentLazySearch {
     page: number;
     size: number;
     sortField: string;
     sortOrder: number;
     search: string;
}


export class CustomerAppointmentLazyOut {
     totalCount: number;
     items: CustomerAppointment[] = [];
}